module.exports = __webpack_public_path__ + "static/media/pdf-bulletins-icon.6dc3b07a.svg";